import React from "react";
import { Container } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import "./AgriStackComponent.css";
import "react-awesome-slider/dist/styles.css";
import ecoSystemViewImg from "../../images/product.png";
import systemViewImg from "../../images/digital.png";
import dataDrivenViewImg from "../../images/monitor.png";
import IoB from "../../images/IoB.svg";
import { NavLink } from "react-router-dom";
import { Typography } from "@material-ui/core";

const stackData = [
  { title: "DataHub Stack", image: dataDrivenViewImg, path: "/data-hub-stack" },
  { title: "DeviceHub Stack", image: systemViewImg, path: "/device-hub-stack" },
  { title: "IoB Stack", image: IoB, path: "/IoB-stack" },
  { title: "Analytics Stack", image: IoB, path: "/analytics-stack" },
  {
    title: "Track And Trace Stack",
    image: ecoSystemViewImg,
    path: "/track-trace-stack",
  },
];

const EdgeAIStack = () => {
  return (
    <div
      maxwidth={12}
      className="businessPartnerContainer explore-app-background"
    >
      <Container maxWidth="sm" className="gridSection gridSection--mod ">
        <Grid
          container={true}
          alignItems="center"
          spacing={1}
          direction="row"
          justifyContent="space-between"
        >
          {stackData.map(({ title, image, path }, index) => {
            return (
              <Grid
                item
                md={2}
                sm={4}
                xs={6}
                key={index}
                className="stack-data-container"
              >
                <NavLink to={path}>
                  <img src={image} alt={title} />
                  <Typography variant="h4" align="center">
                    {title}
                  </Typography>
                </NavLink>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </div>
  );
};

export default EdgeAIStack;
